// fetch polyfill for Safari 10.0.2 support
import 'whatwg-fetch'
import bugsnag from 'bugsnag-js'
import bugsnagVue from 'bugsnag-vue'
import { isProduction } from './views/utils'

export const bugsnagClient = isProduction
  ? bugsnag({
    apiKey: '5d43fb2541825e7988a410d01a051b4c',
    // beforeSend: (report) => {
    //   report.app.releaseStage = window.location.host.includes('localhost')
    //     ? 'development'
    //     : 'production'
    // },
  })
  : null

export function attachVue(vueInstance) {
  bugsnagClient && bugsnagClient.use(bugsnagVue(vueInstance))
}



// WEBPACK FOOTER //
// ./src/bugsnag.js